<template>
  <page layout="tabbed">
    <page-header-new
      :title="$t('ChannelSettings_Title')"
      :breadcrumbs="breadcrumbs"
    />
    <page-tabs :tabs="availableTabs"></page-tabs>
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import PageTabs from '@/common/components/page/PageTabs'
import { projectRoute } from '@/core/helpers'

export default {
  name: 'ChannelSettingsPage',
  components: { PageTabs, PageHeaderNew, Page },
  data() {
    return {
      breadcrumbs: [
        {
          label: this.$t('Settings_Breadcrumb_Settings')
        },
        {
          label: this.$t('Settings_Breadcrumb_Channels')
        }
      ]
    }
  },
  computed: {
    availableTabs() {
      return [
        {
          title: this.$t('ChannelSettings_Tab_EnableChannels'),
          route: projectRoute({ name: 'EnableChannelsTab' })
        },
        {
          title: this.$t('ChannelSettings_Tab_EngagementRules'),
          route: projectRoute({ name: 'EngagementRulesTab' })
        },
        {
          title: this.$t('ChannelSettings_Tab_UrlTracking'),
          route: projectRoute({ name: 'UrlTrackingTab' })
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/settings/pages/ChannelSettingsPage.vue